export default __webpack_public_path__ + "static/leaguespartan-bold-d487d35b527882680f8639ef46c78550.woff2";